import script from "./GuestTab.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestTab.vue?vue&type=script&setup=true&lang=js"

import "./GuestTab.vue?vue&type=style&index=0&id=237ccd4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-237ccd4a"]])

export default __exports__